import React from "react";
import Select from "react-select";

const Category = [
  { value: "india", label: "India" },
  { value: "usa", label: "United States" },
  { value: "uk", label: "United Kingdom" },
  { value: "aus", label: "Australia" },
];
const ServiceType = [
  { value: "india", label: "India" },
  { value: "usa", label: "United States" },
  { value: "uk", label: "United Kingdom" },
  { value: "aus", label: "Australia" },
];

const ServicesDetails = () => {
  return (
    <section className="content mb-5">
      <div className="container-fluid">
        <div className="row titlepad publsih-sticky">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
            <div className="row">
              <div className="col-sm-8">
                <h4>Service Details</h4>
                <p className="page-sub-head">Add/Edit Service</p>
              </div>
              <div className="col-md-4 text-sm-right mt-2">
                <a
                  href="#"
                  className="btn-md px-3 py-2 btn-primary"
                >
                  <i class="fa-regular fa-square-check" aria-hidden="true"></i>{" "}
                  Publish
                </a>
                <a
                  href="javascript:history.back()"
                  className="btn-md px-3 py-2 btn-secondary"
                >
                  <i className="fa fa-chevron-circle-left"></i> Cancel
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-8">
            <div className="tabData mt-4">
              <h6>Enter the details below for create/edit Service</h6>
              <div className="mt-2 mb-2">
                <div className="dashbed-border-bottom"></div>
              </div>
              <div className="pb-4">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Select Category <span className="text-danger">*</span>
                      </label>
                      <Select
                        // className="form-control"
                        classNamePrefix="react-select"
                        isMulti
                        options={Category}
                        placeholder="Select categories..."
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Service Type <span className="text-danger">*</span>
                      </label>
                      <Select
                        // className="form-control"
                        classNamePrefix="react-select"
                        isMulti
                        options={ServiceType}
                        placeholder="Select types..."
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        Service Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Service Name"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Price (in SAR) <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Price (in SAR)"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Ideal Time (in min){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Ideal Time (in min)"
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        Short Description <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        placeholder="Enter Description here"
                      ></textarea>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        About Service<span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows="5"
                        placeholder="Enter About Service"
                      ></textarea>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <label>
                      Upload Images for Gallery{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <table
                      className="table table-striped table-bordered admintable border-0"
                      cellspacing="0"
                      cellpadding="0"
                    >
                      <tbody>
                        <tr>
                          <th>Sr.No.</th>
                          <th>Upload</th>
                          <th>Action</th>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>
                            <input
                              type="file"
                              className="form-control border"
                              placeholder="Enter PM Time"
                            />
                          </td>
                          <td>
                            <a href="#" className="f-16">
                              <i className="fa-regular fa-square-plus"></i>
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>2</td>
                          <td>
                            <input
                              type="file"
                              className="form-control border"
                              placeholder="Enter PM Time"
                            />
                          </td>
                          <td>
                            <a href="#" className="text-danger f-18">
                            <i className="fa-regular fa-trash-can"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <div className="card-header" id="headingOne">
                <h5 className="mb-0">
                  <button className="btn btn-link text-black shadow-none pl-0 pb-0 staturightghead">
                    Status Update
                  </button>
                </h5>
              </div>

              <div className="card-body">
                <div>
                  <label className="logCheck mb-3">
                    <input type="radio" checked name="statusupdate" />
                    <div>Active</div>
                    <span className="checkmark"></span>
                  </label>

                  <label className="logCheck mb-0">
                    <input type="radio" name="statusupdate" />
                    <div>InActive</div>
                    <span className="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesDetails;
